import axios from 'axios';
import { buildApiUrl } from '../config/api';

export const newsletterAPI = {
    subscribe: async (email) => {
        const response = await axios.post(buildApiUrl('/contact/newsletter/subscribe'), { email });
        return response.data;
    },
    
    unsubscribe: async (email) => {
        const response = await axios.post(buildApiUrl('/contact/newsletter/unsubscribe'), { email });
        return response.data;
    }
};
